import styled from 'styled-components';

export const ContainterRemainingTime = styled.div`
  display: flex;
  font-weight: bold;
  font-size: 14px;
`;
export const ContainterItemRemainingTime = styled.div`
  margin-left: 5px;
`;

